module.exports = {"510603001":"旌阳街道","510603002":"城南街道","510603003":"城北街道","510603004":"旌东街道","510603005":"工农街道","510603006":"八角井街道","510603007":"黄河街道","510603008":"天虹街道","510603100":"黄许镇","510603101":"孝泉镇","510603103":"柏隆镇","510603104":"孝感镇","510603105":"天元镇","510603107":"扬嘉镇","510603108":"德新镇","510603110":"双东镇","510603111":"新中镇","510603117":"和新镇","510603201":"东湖乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510603.json
// module id = 2293
// module chunks = 0